import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IEnvPago, IWebPayItem } from './../Entities/webPay.entities';
import { getLocalStorage } from '../helpers/helper';
import { key_user_info } from '../helpers/constants';
import {
  ITokuPaymentRequest,
  ITokuPaymentResponse,
} from '../Entities/toku.entities';
import { ILLVAL } from '../Entities/entities';
@Injectable({
  providedIn: 'root',
})
export class WebPayService {
  vidaUrl = environment.url.api;
  apiURLPago = environment.url.apiPago;
  apiBff = environment.url.apiBff;
  constructor(private http: HttpClient) {}

  limpiarCarro(idCarro): Observable<number> {
    return this.http.put<number>(`${this.apiURLPago}Carro/${idCarro}`, {});
  }

  agregarItemsCarro(polizas: IWebPayItem[]): Observable<number> {
    const userInfo = getLocalStorage(key_user_info);
    const rut = userInfo.rut;

    const body = {
      Rut: rut,
      ItemsCarro: polizas,
    };

    return this.http.post<number>(
      `${this.apiURLPago}Carro`,
      JSON.stringify(body)
    );
  }

  enviarPago(idCarro): Observable<IEnvPago> {
    return this.http.post<IEnvPago>(
      `${this.apiURLPago}TransaccionInicia/${idCarro}`,
      {}
    );
  }

  enviarPagoServipag(idCarro): Observable<IEnvPago> {
    return this.http.get<IEnvPago>(`${this.apiURLPago}XML1/${idCarro}`);
  }

  enviarPagoToku(body: ITokuPaymentRequest): Observable<ITokuPaymentResponse> {
    const token = getLocalStorage('token');
    const clientService = environment.service.postNewPayment;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      dominio: 'SitioPrivado',
      Authorization: 'Bearer ' + token.access_token,
      'x-application': 'SPV'
    });

    const url = `${this.apiBff}/${clientService.endpoint_path}`;
    return this.http.post<ITokuPaymentResponse>(url, JSON.stringify(body), {
      headers
    });
  }

  getTokuEnabledRuts(): Observable<ILLVAL> {
    const p_TIPOLVAL = 'RUTSTOKU';
    const p_CODLVAL = 'RUTS';
    return this.http.get<ILLVAL>(
      `${this.vidaUrl}/com/Servicio/Parametros/lval/${p_TIPOLVAL}/${p_CODLVAL}`
    );
  }
}
